// Token 存储封装
// 统一管理 Token 的存取和删除

const TOKEN_KEY = 'carrot-admin-token'

// 内存存储备用（当 localStorage 不可用时）
let memoryToken: string | null = null

export const authStorage = {
	// 获取 Token
	getToken: (): string | null => {
		try {
			return localStorage.getItem(TOKEN_KEY)
		} catch {
			return memoryToken
		}
	},

	// 设置 Token
	setToken: (token: string): void => {
		try {
			localStorage.setItem(TOKEN_KEY, token)
		} catch {
			memoryToken = token
		}
	},

	// 删除 Token
	removeToken: (): void => {
		try {
			localStorage.removeItem(TOKEN_KEY)
		} catch {
			memoryToken = null
		}
	},

	// 检查是否已登录
	isAuthenticated: (): boolean => {
		return !!authStorage.getToken()
	},
}
